// Consistente lineiconenset (24x24, stroke-based) — geen externe iconenlibrary nodig.
interface IconProps {
  size?: number;
  className?: string;
  title?: string;
}

function base(paths: any, { size = 24, className, title }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      {paths}
    </svg>
  );
}

export const CheckIcon = (p: IconProps = {}) => base(<polyline points="20 6 9 17 4 12" />, p);
export const ShieldIcon = (p: IconProps = {}) =>
  base(
    <>
      <path d="M12 2 4 5v6c0 5 3.4 8.6 8 11 4.6-2.4 8-6 8-11V5l-8-3Z" />
      <polyline points="9 12 11 14 15 10" />
    </>,
    p
  );
export const UsersIcon = (p: IconProps = {}) =>
  base(
    <>
      <path d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
      <circle cx="10" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </>,
    p
  );
export const TagIcon = (p: IconProps = {}) =>
  base(
    <>
      <path d="M20.6 12.6 12 21.2 2.8 12 12.4 2.4H20.6Z" />
      <circle cx="16" cy="8" r="1.2" fill="currentColor" stroke="none" />
    </>,
    p
  );
export const ClockIcon = (p: IconProps = {}) =>
  base(
    <>
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 16 14" />
    </>,
    p
  );
export const PhoneIcon = (p: IconProps = {}) =>
  base(
    <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L8 9.6a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2Z" />,
    p
  );
export const MailIcon = (p: IconProps = {}) =>
  base(
    <>
      <rect x="2.5" y="4.5" width="19" height="15" rx="2.2" />
      <polyline points="3 6 12 13 21 6" />
    </>,
    p
  );
export const MapPinIcon = (p: IconProps = {}) =>
  base(
    <>
      <path d="M20 10.5c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
      <circle cx="12" cy="10.5" r="2.5" />
    </>,
    p
  );
export const CalendarIcon = (p: IconProps = {}) =>
  base(
    <>
      <rect x="3" y="4.5" width="18" height="16" rx="2" />
      <line x1="3" y1="9.5" x2="21" y2="9.5" />
      <line x1="8" y1="2.5" x2="8" y2="6.5" />
      <line x1="16" y1="2.5" x2="16" y2="6.5" />
    </>,
    p
  );
export const FlaskIcon = (p: IconProps = {}) =>
  base(
    <>
      <path d="M9 2h6" />
      <path d="M10 2v6.2L4.5 18a2 2 0 0 0 1.7 3h11.6a2 2 0 0 0 1.7-3L14 8.2V2" />
      <line x1="7.5" y1="14" x2="16.5" y2="14" />
    </>,
    p
  );
export const FileTextIcon = (p: IconProps = {}) =>
  base(
    <>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="8" y1="13" x2="16" y2="13" />
      <line x1="8" y1="17" x2="13" y2="17" />
    </>,
    p
  );
export const MenuIcon = (p: IconProps = {}) =>
  base(
    <>
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </>,
    p
  );
export const XIcon = (p: IconProps = {}) =>
  base(
    <>
      <line x1="5" y1="5" x2="19" y2="19" />
      <line x1="19" y1="5" x2="5" y2="19" />
    </>,
    p
  );
export const ChevronDownIcon = (p: IconProps = {}) => base(<polyline points="6 9 12 15 18 9" />, p);
export const ChevronLeftIcon = (p: IconProps = {}) => base(<polyline points="15 18 9 12 15 6" />, p);
export const ChevronRightIcon = (p: IconProps = {}) => base(<polyline points="9 18 15 12 9 6" />, p);
export const ArrowRightIcon = (p: IconProps = {}) =>
  base(
    <>
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </>,
    p
  );
export const HomeIcon = (p: IconProps = {}) =>
  base(
    <>
      <path d="m3 11 9-8 9 8" />
      <path d="M5 10v10a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V10" />
    </>,
    p
  );
export const BuildingIcon = (p: IconProps = {}) =>
  base(
    <>
      <rect x="4" y="3" width="16" height="18" rx="1" />
      <line x1="8" y1="7" x2="8" y2="7.01" />
      <line x1="12" y1="7" x2="12" y2="7.01" />
      <line x1="16" y1="7" x2="16" y2="7.01" />
      <line x1="8" y1="11" x2="8" y2="11.01" />
      <line x1="12" y1="11" x2="12" y2="11.01" />
      <line x1="16" y1="11" x2="16" y2="11.01" />
      <line x1="8" y1="15" x2="8" y2="15.01" />
      <line x1="12" y1="15" x2="12" y2="15.01" />
      <line x1="16" y1="15" x2="16" y2="15.01" />
      <path d="M9 21v-3h6v3" />
    </>,
    p
  );
export const RowhouseIcon = (p: IconProps = {}) =>
  base(
    <>
      <path d="M3 21V10l4-3 4 3v11" />
      <path d="M11 21v-8l4-3 4 3v8" />
      <line x1="1" y1="21" x2="23" y2="21" />
    </>,
    p
  );
export const SemiDetachedIcon = (p: IconProps = {}) =>
  base(
    <>
      <path d="M2 21V9l5-4 5 4v12" />
      <path d="M12 21V9l5-4 5 4v12" />
      <line x1="1" y1="21" x2="23" y2="21" />
    </>,
    p
  );
export const DetachedIcon = (p: IconProps = {}) =>
  base(
    <>
      <path d="M4 21V11l8-6 8 6v10" />
      <path d="M9 21v-6h6v6" />
      <line x1="2" y1="21" x2="22" y2="21" />
    </>,
    p
  );
export const OtherBuildingIcon = (p: IconProps = {}) =>
  base(
    <>
      <rect x="3" y="7" width="10" height="14" rx="1" />
      <rect x="13" y="3" width="8" height="18" rx="1" />
      <line x1="6" y1="11" x2="6" y2="11.01" />
      <line x1="9" y1="11" x2="9" y2="11.01" />
      <line x1="6" y1="15" x2="6" y2="15.01" />
      <line x1="9" y1="15" x2="9" y2="15.01" />
    </>,
    p
  );
export const BriefcaseIcon = (p: IconProps = {}) =>
  base(
    <>
      <rect x="2.5" y="7" width="19" height="13" rx="2" />
      <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </>,
    p
  );
export const StarIcon = (p: IconProps = {}) =>
  base(
    <polygon points="12 2.5 15.1 8.9 22.2 9.9 17.1 14.8 18.3 21.9 12 18.6 5.7 21.9 6.9 14.8 1.8 9.9 8.9 8.9" />,
    p
  );
export const WhatsappIcon = (p: IconProps = {}) =>
  base(
    <path d="M20.5 3.5A10.5 10.5 0 0 0 3.2 16.3L2 22l5.9-1.2A10.5 10.5 0 1 0 20.5 3.5Zm-8.5 17a8.4 8.4 0 0 1-4.3-1.2l-.3-.2-3.2.8.8-3.1-.2-.3A8.5 8.5 0 1 1 12 20.5Zm4.6-6.4c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1s-.7.8-.9 1c-.2.2-.3.2-.6.1a6.9 6.9 0 0 1-3.4-3c-.3-.4.3-.4.7-1.3.1-.2 0-.4 0-.5L9 7.3c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-1 2.3c0 1.3 1 2.6 1.1 2.8.1.2 2 3 4.8 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3Z" />,
    p
  );
export const LinkedinIcon = (p: IconProps = {}) =>
  base(
    <>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <line x1="8" y1="10" x2="8" y2="17" />
      <circle cx="8" cy="6.5" r="1" fill="currentColor" stroke="none" />
      <path d="M12 17v-4.5a2.5 2.5 0 0 1 5 0V17" />
      <line x1="12" y1="10" x2="12" y2="17" />
    </>,
    p
  );
export const FacebookIcon = (p: IconProps = {}) =>
  base(<path d="M14 21v-8h2.7l.4-3.3H14V7.5c0-1 .3-1.6 1.7-1.6H17V3a13 13 0 0 0-1.9-.1c-2.5 0-4.2 1.5-4.2 4.3v2.5H8.2v3.3H11v8Z" />, p);
export const InstagramIcon = (p: IconProps = {}) =>
  base(
    <>
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <line x1="17.5" y1="6.5" x2="17.5" y2="6.51" />
    </>,
    p
  );
export const UploadIcon = (p: IconProps = {}) =>
  base(
    <>
      <path d="M12 15V4" />
      <polyline points="7 8 12 3 17 8" />
      <path d="M20 16v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3" />
    </>,
    p
  );
export const DownloadIcon = (p: IconProps = {}) =>
  base(
    <>
      <path d="M12 3v12" />
      <polyline points="7 10 12 15 17 10" />
      <path d="M20 21H4" />
    </>,
    p
  );
export const TrashIcon = (p: IconProps = {}) =>
  base(
    <>
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </>,
    p
  );
export const AlertIcon = (p: IconProps = {}) =>
  base(
    <>
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="8" x2="12" y2="13" />
      <line x1="12" y1="16" x2="12" y2="16.01" />
    </>,
    p
  );
export const SearchIcon = (p: IconProps = {}) =>
  base(
    <>
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.5" y2="16.5" />
    </>,
    p
  );
